export default "__VITE_ASSET__GQ9mTxBm__"